export default __webpack_public_path__ + "static/media/support.82fef8ef.svg";